import React from 'react';

import { Controls, Modal } from 'V2/Shared/Modal';
import { PaymentPlanType } from 'V2/Types/Payment';
import { PaymentSchedule } from 'V2/Shared/PaymentSchedule';

import { Button } from '../Button';

export type PaymentScheduleModalType = {
  show: boolean;
  paymentPlan: PaymentPlanType;
  onClose: () => void;
};

export const PaymentScheduleModal: React.FC<PaymentScheduleModalType> = (
  props
) => {
  const { show, paymentPlan, onClose } = props;

  return (
    <Modal showModal={show} closeAction={onClose} title="Payment schedule">
      <PaymentSchedule paymentPlan={paymentPlan} />
      <Controls>
        <Button
          data-testid="payment-schedule-close-button"
          variant="contained"
          size="md"
          onClick={onClose}
        >
          Close
        </Button>
      </Controls>
    </Modal>
  );
};
